import { IconNames } from '@blueprintjs/icons'
import { i18nKeys } from '../../../app.i18n'
import { AssessmentValue, CoreValueOption, ExtendedAssessmentValue } from './rating-value'

export const RatingItems = [
  {
    value: AssessmentValue.NotThatGood,
    text: i18nKeys.frontFace.reviews.rating.notThatGood,
  },
  {
    value: AssessmentValue.AtTheEdge,
    text: i18nKeys.frontFace.reviews.rating.atTheEdge,
  },
  {
    value: AssessmentValue.Successful,
    text: i18nKeys.frontFace.reviews.rating.successful,
  },
  {
    value: AssessmentValue.ExceptionallyGood,
    text: i18nKeys.frontFace.reviews.rating.exceptionallyGood,
  },
]

export const ExtendedRatingItems = [
  {
    value: ExtendedAssessmentValue.ExceptionallyGood,
    text: i18nKeys.frontFace.reviews.ratingText.exceptionallyGood,
  },
  {
    value: ExtendedAssessmentValue.AboveExpectations,
    text: i18nKeys.frontFace.reviews.ratingText.aboveExpectations,
  },
  {
    value: ExtendedAssessmentValue.MeetExpectations,
    text: i18nKeys.frontFace.reviews.ratingText.meetExpectations,
  },
  {
    value: ExtendedAssessmentValue.AtTheEdge,
    text: i18nKeys.frontFace.reviews.ratingText.atTheEdge,
  },
  {
    value: ExtendedAssessmentValue.NotThatGood,
    text: i18nKeys.frontFace.reviews.ratingText.notThatGood,
  },
]

export const ExtendedRatingItemsOnlyNumbers = [
  {
    value: ExtendedAssessmentValue.ExceptionallyGood,
    text: ExtendedAssessmentValue.ExceptionallyGood.toString(),
    withDescription: 'Exceptionally Good',
  },
  {
    value: ExtendedAssessmentValue.AboveExpectations,
    text: ExtendedAssessmentValue.AboveExpectations.toString(),
    withDescription: 'Above Expectations',
  },
  {
    value: ExtendedAssessmentValue.MeetExpectations,
    text: ExtendedAssessmentValue.MeetExpectations.toString(),
    withDescription: 'Meet Expectations',
  },
  {
    value: ExtendedAssessmentValue.AtTheEdge,
    text: ExtendedAssessmentValue.AtTheEdge.toString(),
    withDescription: 'At The Edge',
  },
  {
    value: ExtendedAssessmentValue.NotThatGood,
    text: ExtendedAssessmentValue.NotThatGood.toString(),
    withDescription: 'Not That Good',
  },
]

export function getExtendedRatingItemsEmojiBy(quality: any) {
  const title = quality ? (quality.title ? quality.title : '') : ''
  const isIntegrity = title.includes('quality.integrity.title')
  const isHomeId = !!(quality && quality.competencyLevels)

  return isIntegrity
    ? ExtendedRatingItemsEmoji3
    : isHomeId
      ? ExtendedRatingItemsEmoji3HomeId
      : ExtendedRatingItemsEmoji5
}

export const ExtendedRatingItemsEmoji3 = [
  {
    value: 1,
    text: 'No',
    icon: IconNames.DOWNLOAD,
    color: 'red',
    withDescription: i18nKeys.frontFace.reviews.sections.leadershipQualities.evaluation.short.no, // 'No',
  },
  {
    value: 2,
    text: 'Mostly',
    icon: IconNames.TICK_CIRCLE,
    color: 'green',
    withDescription: i18nKeys.frontFace.reviews.sections.leadershipQualities.evaluation.short.mostly, // 'Mostly',
  },
  {
    value: 3,
    text: 'Yes',
    icon: IconNames.UPLOAD,
    color: 'blue',
    withDescription: i18nKeys.frontFace.reviews.sections.leadershipQualities.evaluation.short.yes, // 'Yes',
  },
]

export const ExtendedRatingItemsEmoji3HomeId = [
  {
    value: 1,
    text: 'Needs Improvement',
    icon: IconNames.DOWNLOAD,
    color: 'red',
    withDescription: i18nKeys.frontFace.reviews.sections.leadershipQualities.evaluation.short.needsImprovement,
  },
  {
    value: 2,
    text: 'Meets Expectations',
    icon: IconNames.TICK_CIRCLE,
    color: 'green',
    withDescription: i18nKeys.frontFace.reviews.sections.leadershipQualities.evaluation.short.meetsExpectations,
  },
  {
    value: 3,
    text: 'Above Expectations',
    icon: IconNames.UPLOAD,
    color: 'blue',
    withDescription: i18nKeys.frontFace.reviews.sections.leadershipQualities.evaluation.short.aboveExpectations,
  },
]

export const ExtendedRatingItemsEmoji5 = [
  {
    value: 1,
    text: 'Significant Below',
    icon: IconNames.DOUBLE_CHEVRON_DOWN,
    color: 'black',
    withDescription: i18nKeys.frontFace.reviews.sections.leadershipQualities.evaluation.short.significantlyBelow, // 'Significant Below',
  },
  {
    value: 2,
    text: 'Below',
    icon: IconNames.DOWNLOAD,
    color: 'red',
    withDescription: i18nKeys.frontFace.reviews.sections.leadershipQualities.evaluation.short.below, // 'Below',
  },
  {
    value: 3,
    text: 'On Par',
    icon: IconNames.TICK_CIRCLE,
    color: 'green',
    withDescription: i18nKeys.frontFace.reviews.sections.leadershipQualities.evaluation.short.onPar, // 'On Par',
  },
  {
    value: 4,
    text: 'Above',
    icon: IconNames.UPLOAD,
    color: 'blue',
    withDescription: i18nKeys.frontFace.reviews.sections.leadershipQualities.evaluation.short.above, // 'Above',
  },
  {
    value: 5,
    text: 'Excellent',
    icon: IconNames.DOUBLE_CHEVRON_UP,
    color: '#d6b400',
    withDescription: i18nKeys.frontFace.reviews.sections.leadershipQualities.evaluation.short.exceptional, // 'Excellent',
  },
]

export const OverallPerformanceSelectAble = [
  {
    value: 1,
    title: i18nKeys.frontFace.reviews.ratingText.notThatGood,
    text: i18nKeys.frontFace.reviews.ratingText.notThatGoodDescription,
    boldText: i18nKeys.frontFace.reviews.ratingText.notThatGoodDescriptionBold,
  },
  {
    value: 2,
    title: i18nKeys.frontFace.reviews.ratingText.atTheEdge,
    text: i18nKeys.frontFace.reviews.ratingText.atTheEdgeDescription,
    boldText: i18nKeys.frontFace.reviews.ratingText.atTheEdgeDescriptionBold,
  },
  {
    value: 3,
    title: i18nKeys.frontFace.reviews.ratingText.meetExpectations,
    text: i18nKeys.frontFace.reviews.ratingText.meetExpectationsDescription,
    boldText: i18nKeys.frontFace.reviews.ratingText.meetExpectationsDescriptionBold,
  },
  {
    value: 4,
    title: i18nKeys.frontFace.reviews.ratingText.aboveExpectations,
    text: i18nKeys.frontFace.reviews.ratingText.aboveExpectationsDescription,
    boldText: i18nKeys.frontFace.reviews.ratingText.aboveExpectationsDescriptionBold,
  },
  {
    value: 5,
    title: i18nKeys.frontFace.reviews.ratingText.exceptionallyGood,
    text: i18nKeys.frontFace.reviews.ratingText.exceptionallyGoodDescription,
    boldText: i18nKeys.frontFace.reviews.ratingText.exceptionallyGoodDescriptionBold,
  },
]

export const CoreValueItems = [
  {
    value: CoreValueOption.BeEntepreneurial,
    text: i18nKeys.frontFace.reviews.coreValue.beEntepreneurial,
  },
  {
    value: CoreValueOption.BeFocused,
    text: i18nKeys.frontFace.reviews.coreValue.beFocused,
  },
  {
    value: CoreValueOption.BeInnovative,
    text: i18nKeys.frontFace.reviews.coreValue.beInnovative,
  },
  {
    value: CoreValueOption.BeFair,
    text: i18nKeys.frontFace.reviews.coreValue.beFair,
  },
]



// WEBPACK FOOTER //
// ./src/app/front-face/shared/review/form-lookups.ts